// extracted by mini-css-extract-plugin
module.exports = {"root":"PopupDeclineStatus_root__y0htl","iconWrapper":"PopupDeclineStatus_iconWrapper__b5RHS"};